import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Regions } from '../../hooks/useConfiguration';
import { assertNever } from '../../utils/assertNever';

export const Contact: React.FC<{
  region: Regions;
}> = ({ region }) => {
  const { t: tRegion } = useTranslation(region);
  const { t } = useTranslation();
  switch (region) {
    case 'us':
      return (
        <>
          <h3>{t('privacy.contact.title')}</h3>
          <div className='contacts-block'>
            {tRegion('contactData.address')}
            <br />
            {tRegion('privacy.contact.phone')}
            <br />
            <Trans t={tRegion} i18nKey='privacy.contact.email'>
              <a className='contacts-block__link' href={`mailto:${tRegion('contactData.mailTo')}`}>
                info@lm-americas.com
              </a>
            </Trans>
          </div>
        </>
      );

    case 'eu':
      return (
        <>
          <h3>{t('privacy.contact.title')}</h3>
          <div className='contacts-block'>
            {tRegion('contactData.companyName')}
            <br />
            {tRegion('contactData.street')}
            <br />
            {tRegion('contactData.city')}
            <br />
            {tRegion('contactData.country')}
            <br />
            <Trans t={tRegion} i18nKey='privacy.contact.email'>
              <a className='contacts-block__link' href={`mailto:${tRegion('privacy.contact.mailTo')}`}>
                info@lm-americas.com
              </a>
            </Trans>
            <br />
            {tRegion('privacy.contact.phone')}
          </div>
        </>
      );

    default:
      assertNever(region);
  }
};
